export const props = {
    MuiButton: {
        variant: 'contained',
        disableElevation: true,
    },
    MuiInputLabel: {
        disableAnimation: true,
        shrink: true,
    },
    MuiSelect: {
        MenuProps: {
            anchorOrigin: {
                horizontal: 'left',
                vertical: 'top',
            },
            getContentAnchorEl: null,
        },
        variant: 'outlined',
    },
    MuiTextField: {
        InputLabelProps: {
            disableAnimation: true,
            shrink: true,
        },
        variant: 'outlined',
    },
};
